/*@flow*/
import building from './building';
import contact from './contact';
import development from './development';
import event from './event';
import listing from './listing';
import property from './property';
import streetscapeAsset from './streetscapeAsset';
import streetscapeIssue from './streetscapeIssue';
import tenant from './tenant';
import unit from './unit';
import organization from './organization';

export default {
  Building: building,
  Contact: contact,
  Development: development,
  Event: event,
  Listing: listing,
  Property: property,
  StreetscapeAsset: streetscapeAsset,
  StreetscapeIssue: streetscapeIssue,
  Tenant: tenant,
  Unit: unit,
  Organization: organization,
};
